/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Downloads_Errorprefix1Inputs */

const id_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error:`)
};

const ms_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ralat:`)
};

const da_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejl:`)
};

const de_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler:`)
};

const en_us2_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error:`)
};

const es_es2_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error:`)
};

const es_mx2_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error:`)
};

const fil_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error:`)
};

const fr_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur :`)
};

const it_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore:`)
};

const hu_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiba:`)
};

const nl_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout:`)
};

const no_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feil:`)
};

const pl_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błąd:`)
};

const pt_br2_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro:`)
};

const pt_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro:`)
};

const ro_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eroare:`)
};

const fi_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virhe:`)
};

const sv_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fel:`)
};

const vi_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi:`)
};

const tr_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hata:`)
};

const cs_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyba:`)
};

const bg_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Грешка:`)
};

const ru_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка:`)
};

const uk_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помилка:`)
};

const ar_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطأ:`)
};

const hi_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्रुटि:`)
};

const th_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อผิดพลาด:`)
};

const ja_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー：`)
};

const zh_cn2_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误：`)
};

const zh_hant1_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`錯誤：`)
};

const ko_misc_downloads_errorprefix1 = /** @type {(inputs: Misc_Downloads_Errorprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오류:`)
};

/**
* | output |
* | --- |
* | "Error:" |
*
* @param {Misc_Downloads_Errorprefix1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_downloads_errorprefix1 = /** @type {((inputs?: Misc_Downloads_Errorprefix1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Downloads_Errorprefix1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_downloads_errorprefix1(inputs)
	if (locale === "ms") return ms_misc_downloads_errorprefix1(inputs)
	if (locale === "da") return da_misc_downloads_errorprefix1(inputs)
	if (locale === "de") return de_misc_downloads_errorprefix1(inputs)
	if (locale === "en-US") return en_us2_misc_downloads_errorprefix1(inputs)
	if (locale === "es-ES") return es_es2_misc_downloads_errorprefix1(inputs)
	if (locale === "es-MX") return es_mx2_misc_downloads_errorprefix1(inputs)
	if (locale === "fil") return fil_misc_downloads_errorprefix1(inputs)
	if (locale === "fr") return fr_misc_downloads_errorprefix1(inputs)
	if (locale === "it") return it_misc_downloads_errorprefix1(inputs)
	if (locale === "hu") return hu_misc_downloads_errorprefix1(inputs)
	if (locale === "nl") return nl_misc_downloads_errorprefix1(inputs)
	if (locale === "no") return no_misc_downloads_errorprefix1(inputs)
	if (locale === "pl") return pl_misc_downloads_errorprefix1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_downloads_errorprefix1(inputs)
	if (locale === "pt") return pt_misc_downloads_errorprefix1(inputs)
	if (locale === "ro") return ro_misc_downloads_errorprefix1(inputs)
	if (locale === "fi") return fi_misc_downloads_errorprefix1(inputs)
	if (locale === "sv") return sv_misc_downloads_errorprefix1(inputs)
	if (locale === "vi") return vi_misc_downloads_errorprefix1(inputs)
	if (locale === "tr") return tr_misc_downloads_errorprefix1(inputs)
	if (locale === "cs") return cs_misc_downloads_errorprefix1(inputs)
	if (locale === "bg") return bg_misc_downloads_errorprefix1(inputs)
	if (locale === "ru") return ru_misc_downloads_errorprefix1(inputs)
	if (locale === "uk") return uk_misc_downloads_errorprefix1(inputs)
	if (locale === "ar") return ar_misc_downloads_errorprefix1(inputs)
	if (locale === "hi") return hi_misc_downloads_errorprefix1(inputs)
	if (locale === "th") return th_misc_downloads_errorprefix1(inputs)
	if (locale === "ja") return ja_misc_downloads_errorprefix1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_downloads_errorprefix1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_downloads_errorprefix1(inputs)
	return ko_misc_downloads_errorprefix1(inputs)
});
export { misc_downloads_errorprefix1 as "misc.downloads.errorPrefix" }